<h4 matDialogTitle>{{'front.modaleCharteDeontologique.titre' | translate}}</h4>

<mat-dialog-content style="max-height: 450px">
  <div [innerHTML]="texte | safeHtml"></div>
</mat-dialog-content>

<mat-dialog-actions>


  @if (data !== false) {
    <div class="zone-checkbox-modal">
      @if (!documentChartDeontologieChexbox) {
        <div>
          <input type="checkbox" class="square" [(ngModel)]="documentChartDeontologieChexbox"
            (ngModelChange)="sign()">
            <span class="text-notValid">{{'front.modaleCharteDeontologique.declaration'|translate}}</span>
          </div>
        }
        @if (documentChartDeontologieChexbox) {
          <mat-checkbox [checked]="true" [disabled]="true">
            <span>
              {{'front.modaleCharteDeontologique.luEtApprouve' | translate}} {{documentChartDeontologie?.dateSignature | date : dateShort}}
            </span>
          </mat-checkbox>
        }
        <div class="clearfix"></div>
      </div>
    }


    @if (data === false) {
      <button mat-button [mat-dialog-close]="false">{{'general.close' | translate}}</button>
    }


  </mat-dialog-actions>


